var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1982 5.47266H21.4712V17.5261H14.1982V5.47266Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9469 11.5005C14.946 10.3399 15.2053 9.19425 15.7052 8.1503C16.205 7.10636 16.9324 6.19147 17.8321 5.47486C16.7177 4.58618 15.3794 4.03355 13.9701 3.88015C12.5608 3.72676 11.1374 3.97877 9.86263 4.6074C8.58782 5.23602 7.51302 6.2159 6.76107 7.43503C6.00911 8.65416 5.61035 10.0634 5.61035 11.5016C5.61035 12.9398 6.00911 14.349 6.76107 15.5681C7.51302 16.7873 8.58782 17.7671 9.86263 18.3958C11.1374 19.0244 12.5608 19.2764 13.9701 19.123C15.3794 18.9696 16.7177 18.417 17.8321 17.5283C16.9321 16.8115 16.2046 15.8962 15.7047 14.8519C15.2048 13.8076 14.9457 12.6615 14.9469 11.5005V11.5005Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 16.2507V16.0038H29.4382V15.9526H29.1885V16.0038H29.2871V16.2508L29.3332 16.2507ZM29.818 16.2507V15.9527H29.7424L29.6543 16.1656L29.5661 15.9526H29.4906V16.2507H29.5452V16.025L29.627 16.2188H29.6837L29.7655 16.025V16.2507H29.818Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.055 11.5006C30.0549 12.939 29.6561 14.3483 28.904 15.5674C28.1519 16.7866 27.0769 17.7665 25.802 18.395C24.527 19.0235 23.1034 19.2754 21.6941 19.1218C20.2847 18.9682 18.9464 18.4153 17.832 17.5263C18.7314 16.809 19.4586 15.8939 19.9586 14.8499C20.4586 13.8059 20.7184 12.6603 20.7184 11.4996C20.7184 10.3388 20.4586 9.19322 19.9586 8.14922C19.4586 7.10522 18.7314 6.19008 17.832 5.47284C18.9464 4.58386 20.2847 4.03097 21.6941 3.87735C23.1035 3.72372 24.527 3.97558 25.802 4.60412C27.0769 5.23266 28.1519 6.21252 28.904 7.4317C29.6561 8.65088 30.0549 10.0602 30.055 11.4985V11.5006Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.3c34366ecad8af3d37378310ca198348.svg";
export { ForwardRef as ReactComponent };